import {
  Box,
  Button,
  Collapse,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { InsertDriveFileOutlined as InsertDriveFileOutlinedIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import { Report } from '../types';
import { SqoFile } from '@/common';
import ReportFilesModal from './ReportsFilesModal';

type ReportsProps = {
  reports: Report[];
  visitId: string;
};

const Reports = ({ reports, visitId }: ReportsProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [answerType, setAnswerType] = useState<'rec' | 'nonConf' | null>(null);
  const [reportsData, setReportsData] = useState<Report[]>(reports);
  const [reportFilesModal, setReportFilesModal] = useState<{
    isOpen: boolean;
    reportId: string;
    files: SqoFile[];
  }>({
    isOpen: false,
    reportId: '',
    files: [],
  });
  const handleClick = (id: string) => {
    const newList = reportsData.map((report) => {
      if (id === report.id) {
        const tmp = {
          ...report,
          // open: !report.open,
        };
        return tmp;
      }
      return report;
    });

    setReportsData(newList);
  };

  // const renderExpandButton = (report: Report) => {
  //   if (report.nonConforms.length && report.open) {
  //     return <ExpandLessIcon />;
  //   }
  //   if (report.nonConforms.length && !report.open) {
  //     return <ExpandMoreIcon />;
  //   }
  //   return null;
  // };

  return (
    <>
      <ReportFilesModal
        reportId={reportFilesModal.reportId}
        reports={reportsData}
        show={reportFilesModal.isOpen}
        setShow={(show: boolean) =>
          setReportFilesModal({
            isOpen: show,
            files: reportFilesModal.files,
            reportId: reportFilesModal.reportId,
          })
        }
      />
      <List
        sx={{ width: '100%', borderRadius: '4px', boxShadow: 1 }}
        component="div"
        aria-labelledby="report-list"
      >
        {reportsData.map((report) => (
          <Box component="div" key={report.id}>
            <ListItemButton onClick={() => handleClick(report.id)}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '1.25rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
                primary={report.name}
                secondary={
                  <Box>
                    <Typography>
                      {t('Note', { defaultValue: 'Note' })}: {report.note}
                    </Typography>
                    <Typography>
                      {t('Status', { defaultValue: 'Status' })}: {report.status}
                    </Typography>
                  </Box>
                }
              />
              <Tooltip title={t('Files', { defaultValue: 'Files' })} placement="top">
                <IconButton
                  onClick={() =>
                    setReportFilesModal({
                      isOpen: true,
                      reportId: report.id,
                      files: report.files,
                    })
                  }
                >
                  <InsertDriveFileOutlinedIcon />
                </IconButton>
              </Tooltip>
            </ListItemButton>

            {reports?.length > 0
              ? report.nonConforms.map((nonConform) => (
                  <Collapse
                    // in={report.open}
                    timeout="auto"
                    unmountOnExit
                    key={`${nonConform.id} + ${report.id}}`}
                  >
                    <List component="div" dense disablePadding>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemText
                          primaryTypographyProps={{ fontSize: '1.25rem' }}
                          secondaryTypographyProps={{ fontSize: '1rem' }}
                          primary={nonConform.note ?? 'N/A'}
                          secondary={nonConform.dat ?? ''}
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>
                ))
              : null}
          </Box>
        ))}
      </List>
    </>
  );
};

export default Reports;
